import ConsultationForm from "./ConsultationForm";

export default function ConsultationModal({ open, onClose }) {
    if (!open) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div
                className="modal-content"
                onClick={(e) => e.stopPropagation()}
            >
                <button className="modal-close" onClick={onClose}>
                    ×
                </button>

                <h3 className="modal-title">Atur Jadwal Konsultasi</h3>
                <p className="modal-subtitle mb-2">
                    Isi form untuk menjadwalkan konsultasi dengan konsultan kami.
                </p>

                <ConsultationForm />
            </div>
        </div>
    );
}